<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col md="6" lg="6">
        <v-card>
          <v-card-text flat>
            <v-form ref="form" @submit.prevent="submit()">
              <v-snackbar v-model="successMessage" color="green" top right>
                Call note added successfully to {{ callNumber }}.
              </v-snackbar>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="form.call_id"
                    label="Select Call"
                    outlined
                    :filter="filterObject"
                    :items="filteredFullCalls"
                    item-value="id"
                    prepend-inner-icon="mdi-phone-log"
                    :rules="[rules.required]"
                    return-object
                    @change="setCallNumber"
                  >
                    <template #selection="{ item }">
                      {{ item.call_number }}
                    </template>
                    <template #item="{ item }">
                      <v-row>
                        <v-col md="3">
                          <div class="caption">Call Number</div>
                          <div class="primary--text font-weight-bold">
                            {{ item.call_number }}
                          </div>
                        </v-col>
                        <v-col md="3">
                          <div class="caption">Call Type</div>
                          <div class="primary--text font-weight-bold">
                            {{ item.call_type_description }}
                          </div>
                        </v-col>
                        <v-col md="6">
                          <div class="caption">Location</div>
                          <div class="primary--text font-weight-bold">
                            {{ getAddress(item.locations) }}
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="form.call_note"
                    outlined
                    label="Call Note"
                    prepend-inner-icon="mdi-pencil-plus"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn large block type="submit" color="primary"
                    >Submit</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import * as axios from 'axios'

export default {
  name: 'CallNote',

  data() {
    return {
      successMessage: false,
      callNumber: '',
      search: '',
      form: {
        call_note_type_id: 'CJIS',
      },
      rules: {
        required: (value) => !!value || 'Required.',
      },
    }
  },

  async mounted() {
    document.title = 'Add Call Note'
    await this.getAll('settings')
    const workstationSettingId = this.settings.find(
      (e) => e.setting_name === 'cjis_workstation_id',
    ).setting_value
    await this.productLogon(workstationSettingId)
  },

  computed: {
    ...mapState({
      full_calls: (s) => s.full_calls_state,
      call_types: (s) => s.call_types_state,
      settings: (s) => s.settings_state,
    }),

    filteredFullCalls() {
      if (!this.full_calls || !this.call_types) return []
      let fullCalls = JSON.parse(JSON.stringify(this.full_calls))
      let callTypes = JSON.parse(JSON.stringify(this.call_types))

      return fullCalls.map((call) => {
        const { master_call_type_id } = call
        console.log('master_call_type_id', master_call_type_id)
        if (master_call_type_id) {
          const callType = callTypes.find(
            (type) => type.master_call_type_id === master_call_type_id,
          )

          call.call_type_description = callType?.description || 'No Call Type'
        } else {
          call.call_type_description = '-'
        }
        return call
      })
    },
  },

  methods: {
    ...mapActions(['getAll']),

    getAddress(locations) {
      if (locations.length) {
        return locations[0].address ? locations[0].address : '-'
      } else {
        return '-'
      }
    },

    filterObject(item, queryText) {
      const { locations } = item
      if (locations.length) {
        const { address } = locations[0]
        if (address) {
          return (
            item.call_number.toLowerCase().includes(queryText.toLowerCase()) ||
            item.call_type_description
              .toLowerCase()
              .includes(queryText.toLowerCase()) ||
            item.locations[0].address
              .toLowerCase()
              .includes(queryText.toLowerCase())
          )
        } else {
          return (
            item.call_number.toLowerCase().includes(queryText.toLowerCase()) ||
            item.call_type_description
              .toLowerCase()
              .includes(queryText.toLowerCase())
          )
        }
      } else {
        return (
          item.call_number.toLowerCase().includes(queryText.toLowerCase()) ||
          item.call_type_description
            .toLowerCase()
            .includes(queryText.toLowerCase())
        )
      }
    },

    async submit() {
      const { form, apiBase } = this
      const tenant_id = document.cookie
        .split(';')
        .find((e) => e.startsWith(' tenant_id'))
        .split('=')[1]

      this.$set(form, 'tenant_id', tenant_id)
      this.$set(form, 'call_id', form.call_id.id)
      try {
        if (this.$refs.form.validate()) {
          await axios.post(`${apiBase()}call-notes`, form)
          // this.callNote = `${form.call_id}`
          this.successMessage = true
          this.$refs.form.reset()
        }
      } catch (error) {
        console.log('error', error)
      }
    },

    setCallNumber(call) {
      this.callNumber = call ? call.call_number : ''
    },

    apiBase() {
      let domain = window.location.hostname
      let indexOfDomainStart = domain.indexOf('.')
      if (domain !== 'localhost') {
        if (domain.split('.').length == 3) {
          return (
            window.location.protocol +
            '//cad-api' +
            domain.substring(indexOfDomainStart) +
            '/api/v1/'
          )
        }
        if (domain.split('.').length == 2) {
          return window.location.protocol + '//cad-api.' + domain + '/api/v1/'
        }
      } else {
        return process.env.VUE_APP_API_URL
      }
    },

    authBase() {
      let domain = window.location.hostname
      let indexOfDomainStart = domain.indexOf('.')
      if (domain !== 'localhost') {
        if (domain.split('.').length == 3) {
          return (
            window.location.protocol +
            '//auth' +
            domain.substring(indexOfDomainStart) +
            '/api/v1/'
          )
        }
        if (domain.split('.').length == 2) {
          return window.location.protocol + '//auth.' + domain + '/api/v1/'
        }
      } else {
        return process.env.VUE_APP_AUTH_URL
      }
    },

    async productLogon(id) {
      if (!id) return
      const { authBase, getAll } = this
      const {
        data: { updated_token },
      } = await axios.post(`${authBase()}auth/product-logon/cad`, {
        workstation_id: id,
      })
      axios.defaults.headers.common['Authorization'] = `Bearer ${updated_token}`
      const callTypes = getAll('call-types')
      const fullCalls = getAll('full-calls')
      await callTypes
      await fullCalls
    },
  },
}
</script>

<style></style>
